module.exports = __webpack_public_path__ + "img/music_on_hover.44bc2de4.svg";